<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" plain @click="createSelf" icon="el-icon-plus">{{isMB?'早读':'添加早读'}}</el-button>
        <el-button type="primary" plain @click="createSelf2" icon="el-icon-plus">{{isMB?'晚休':'添加晚休'}}</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="isMB?85:100">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.SectionId)">编辑</el-button>
            <el-button type="text" v-if="row.SectionNumber==0||row.SectionNumber>=100" @click="delRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/ed/section/list";
import editDialog from "@/components/ed/section/editDialog";

export default {
  name: "section",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/ed/section").default,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    createSelf() {
      this.$refs.editDialog.openCreate({ SectionNumber: 0, SelfStudy: 1 });
    },
    createSelf2() {
      this.$refs.editDialog.openCreate({ SectionNumber: 0, SelfStudy: 2 });
    },
    delRow(row) {
      this.$confirm("确认删除该节次吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var name = "deleteMorning";
          if(row.SectionNumber >= 100 ) {
            name = "deleteNight";
          }
          this.api[name](row.SectionId).then(res => {
            if(res.Code==0) {
              this.$message.success("删除成功");
              this.reload();
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.SectionId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>